import {ServiceBase} from "../ServiceBase";
import {
    IRestrictionRulerService,
    LOGIN_ACTION,
    SHOW_MESSAGE_ACTION_TYPE,
    SOF_MESSAGE_ID
} from "./restriction-ruler.service.interface";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {
    RestrictionRulerController_GetRestrictionActionsResponse,
    RestrictionRulerController_NotifyRestrictionActionPerformedRequest
} from "../api/api.service";
import {SourceOfFundsPopupComponent} from "../../components/source-of-funds/source-of-funds-popup.component";
import React from "react";
import {AppIdentifiers, AreaType, ChatOpenMode} from '@sparkware/uc-sdk-core';
import {DISPLAY_MESSAGE_IDS} from "../../../common/const/casinofied-analytics-consts";


export class RestrictionRulerService extends ServiceBase implements IRestrictionRulerService{
    constructor(services: IServiceFactoryExtended) {
        super(services);
        if(!this.services.miniOrbit.isEnabled) {
            this.reaction( () => this.services.user.isAuthorized,
                (isAuthorized) => {
                    const currentRegulationCode = this.services.regulation.getRegulationCode();
                    const enableSOF = this.services.configuration.servicesConfigs.RestrictionRuler.enableSOF;
                    if (isAuthorized && !this.services.sdk.isLoginFromRegistration && enableSOF && enableSOF[currentRegulationCode]){
                        this._executeRestrictionRulerActions()
                    }

                },
                {fireImmediately: true}
            )
        }

    }

    private async _executeRestrictionRulerActions() {
        try {
            let restrictionRulerResponse: RestrictionRulerController_GetRestrictionActionsResponse = await this.services.api.restrictionRulerController.getRestrictionActions(
                {
                    RequestedAction: LOGIN_ACTION
                });

            this._showSourceOfFundsMessage(restrictionRulerResponse);

        } catch (error) {
            this.services.logger.error('Restriction Ruler Service Get Restriction Actions: ', error);
        }

    }
    private async _notifyRestrictionActionPerformed(businessCorrelationID: string, actionType: string, actionData: any) {

        let request: RestrictionRulerController_NotifyRestrictionActionPerformedRequest = {
            restrictionRuleActionType: actionType,
            actionData: JSON.stringify(actionData || {})

        };
        await this.services.api.restrictionRulerController.notifyRestrictionActionPerformed(request);
        // TODO - send message that the show is going to open ?
        await this.services.appLauncher.openChat({
            businessCorrelationID: businessCorrelationID,
            appSpecificParameters: {
                openMode: ChatOpenMode.SOF
            },
            channel: {
                area: AreaType.Message,
                source: AppIdentifiers.CasinoClient,
                element: 'sof_required'
            }
        });
    }

    private _showSourceOfFundsMessage(restrictionRulerResponse: RestrictionRulerController_GetRestrictionActionsResponse){
        let showMessageActions = restrictionRulerResponse.actions.filter(action => action.type === SHOW_MESSAGE_ACTION_TYPE && action.actionData?.messageId === SOF_MESSAGE_ID);
        if (showMessageActions.length === 0) {
            return;
        }
        const businessCorrelationID = this.services.tools.getGuid();
        const action = showMessageActions[0];


        this.services.casinofiedAnalytics.messageDisplay({
            businessCorrelationID: businessCorrelationID,
            displayMessageID: DISPLAY_MESSAGE_IDS.sofRequired //TODO - what should be the value for displayMessageID ?
        });


        this.services.dialog.showModal(dialogHandler =>
            <SourceOfFundsPopupComponent
                dialogHandler={dialogHandler}
                messageRow1={this.services.translation.translate('SOURCE_OF_FUNDS_MESSAGE1')}
                messageRow2={this.services.translation.translate('SOURCE_OF_FUNDS_MESSAGE2')}
                openChatLabel={this.services.translation.translate('SOURCE_OF_FUNDS_OPEN_CHAT_BTN')}/>,
                {
                    icon: this.services.theme.currentTheme.icons.sourceOfFundsIcon,
                    isHighPriority: true,
                    hideCloseButton: true,
                    title: this.services.translation.translate('SOURCE_OF_FUNDS_TITLE'),
                    mobileCenterHeader: true,
                    forceCentralization: true,
                    disableFullscreenMobile: true,
                    forceTransparentBackground: true,
                    onClosed: () => this._notifyRestrictionActionPerformed(businessCorrelationID, action.type, action.actionData)
                }
        )
    }
}
